<div class="container" [class.edit-mode]="reposeGroupEditMode" [class.disabled]="!userCanEdit">
    <div class="td group-id" data-cy="repose-table-group-no">
        {{ index + 1 }}
    </div>
    <div class="td name" data-cy="repose-table-group-name">
        {{ reposeGroup.name }}
        <div class="description" [class.disabled]="!reposeGroup.description" data-cy="repose-table-description">
            {{ getDescription() }}
        </div>
    </div>
    <div class="td trigger">
        <div class="channel">
            <div
                class="channel-name text-button"
                data-cy="repose-table-channel-name"
                (click)="openSearchChannelDialog($event)"
                [class.blue-bg]="this.channel"
                *ngIf="this.channel">
                {{ getChannelName() }}
            </div>
        </div>
        <div class="channel-type" data-cy="repose-table-channel-type" *ngIf="this.channel">
            {{ channel?.opsData.channelType }}
        </div>
        <div class="condition" data-cy="repose-table-condition" *ngIf="this.channel">
            {{ getTriggerCondition() + ' ' + getValue() }}
        </div>

        <div class="channel" *ngIf="!this.channel">
            <div class="disabled">
                {{ 'repose-group.page.table.header.trigger-channel.not-selected' | translate }}
            </div>

            <div class="channel-error-wrapper">
                <div class="channel-name text-button red" (click)="openSearchChannelDialog($event)">
                    {{ 'repose-group.dialog.configuration.select-channel-button' | translate }}
                </div>
                <div class="error-icon">
                    <mat-icon
                        svgIcon="save-error"
                        (mouseenter)="isInfoMessageVisible = true"
                        (mouseleave)="isInfoMessageVisible = false" />
                    <div class="info-message-container" *ngIf="isInfoMessageVisible">
                        <div>
                            {{ 'repose-group.page.no-trigger-channel.message.part1' | translate }}
                        </div>
                        <br />
                        <div>
                            {{ 'repose-group.page.no-trigger-channel.message.part2' | translate }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="td delay-on" [class.disabled]="!reposeGroup.startDelay" data-cy="repose-table-on-delay">
        {{ getDelayString(reposeGroup.startDelay) }}
    </div>
    <div class="td delay-off" [class.disabled]="!reposeGroup.stopDelay" data-cy="repose-table-off-delay">
        {{ getDelayString(reposeGroup.stopDelay) }}
    </div>

    <div class="col-options" #optionsIcon>
        <mat-icon
            svgIcon="more-options"
            class="icon"
            data-cy="repose-table-kebab-icon"
            (click)="openOptions()"></mat-icon>
        <ng-container *ngIf="optionsVisible">
            <div class="more-options-container" #otherOptions>
                <div
                    class="option-row"
                    data-cy="repose-table-edit-button"
                    (click)="editReposeGroup(); $event.stopPropagation()">
                    {{ 'repose-group.table.row.option.edit' | translate }}
                </div>
                <div
                    class="option-row"
                    data-cy="repose-table-delete-button"
                    (click)="deleteRow(); $event.stopPropagation()">
                    {{ 'repose-group.table.row.option.delete' | translate }}
                </div>
            </div>
        </ng-container>
    </div>
</div>
